import * as React from "react";
import { forwardRef } from "react";
const SvgMedia = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#FC2361", fillRule: "evenodd", d: "M3.6 3.748v10.83c0 .824.91 1.324 1.607.882l8.508-5.414a1.045 1.045 0 000-1.764L5.207 2.865a1.046 1.046 0 00-1.607.883z" }));
const ForwardRef = forwardRef(SvgMedia);
export default ForwardRef;
